import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { ThirdPartyAppsFeatureService } from './third-party-apps-feature.service';
import { SettingsService } from './settings/settings.service';

@Injectable({
    providedIn: 'root',
})
export class ThirdPartyAppsEnabledGuard implements CanActivate, CanActivateChild {
    constructor(
        private readonly featureService: ThirdPartyAppsFeatureService,
        private readonly settingsService: SettingsService,
        private readonly router: Router,
    ) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
        return this.evaluate();
    }

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
        return this.evaluate();
    }

    private evaluate(): Observable<boolean | UrlTree> {
        return this.settingsService.isReady.pipe(
            filter(isReady => isReady === true),
            take(1),
            map(() => this.featureService.isEnabled()
                ? true
                : this.router.createUrlTree(['/dashboards/home'])),
        );
    }
}
